
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import moment from 'moment';
import { schedule4DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import {replyExistingChildSupportDataInfoType, rflmCalculatingChildSupportDataInfoType, rflmUnpaidChildSupportDataInfoType, disagreeExistingChildSupportDataInfoType} from "@/types/Application/ReplyFamilyLawMatter/ChildSupport"

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule4 extends Vue {

    @Prop({required:true})
    result!: any;

    dataReady = false;   
    exChSupInfo = {} as schedule4DataInfoType;
   
    mounted(){
        this.dataReady = false;      
        this.extractInfo();       
        this.dataReady = true;       
    }

    public extractInfo(){         
        this.exChSupInfo = this.getExistingChildSupportInfo();
    }

    public getExistingChildSupportInfo(){

        let existingChildSupportInfo = {} as schedule4DataInfoType;       
        

        if (this.result.replyExistingChildSupportSurvey && this.result.rflmUnpaidChildSupportSurvey 
                && this.result.rflmCalculatingChildSupportSurvey && this.result.disagreeExistingChildSupportSurvey){

            const replyExistingChildSupportInfo: replyExistingChildSupportDataInfoType = this.result.replyExistingChildSupportSurvey;
            if (replyExistingChildSupportInfo.existingType == 'finalOrder'){
                existingChildSupportInfo.agreeCircumstanceChanges = replyExistingChildSupportInfo.agreeFinalOrder == 'y';
                existingChildSupportInfo.disAgreeCircumstanceChanges = replyExistingChildSupportInfo.agreeFinalOrder == 'n';
                existingChildSupportInfo.section150 = false;
                existingChildSupportInfo.agreeSetAside = false;

            } else if (replyExistingChildSupportInfo.existingType == 'agreement'){
                existingChildSupportInfo.section150 = replyExistingChildSupportInfo.agreeAgreement == 'y';
                existingChildSupportInfo.agreeSetAside = replyExistingChildSupportInfo.agreeAgreement == 'n';
                existingChildSupportInfo.agreeCircumstanceChanges = false;
                existingChildSupportInfo.disAgreeCircumstanceChanges = false;
            }

            const rflmUnpaidChildSupportInfo: rflmUnpaidChildSupportDataInfoType = this.result.rflmUnpaidChildSupportSurvey;

            existingChildSupportInfo.unpaidDetails = {
                agreeAmount: rflmUnpaidChildSupportInfo.agreeChildSupportAmount == 'y',
                crntDate: rflmUnpaidChildSupportInfo.agreeChildSupportAmount == 'n'? Vue.filter('beautify-date')(rflmUnpaidChildSupportInfo.calculationDate):'',
                unpaidAmnt: rflmUnpaidChildSupportInfo.agreeChildSupportAmount == 'n'?rflmUnpaidChildSupportInfo.unPaidAmount:''

            }           
            const calculationInfo: rflmCalculatingChildSupportDataInfoType = this.result.rflmCalculatingChildSupportSurvey;
                    
            existingChildSupportInfo.calc = {                
                attaching: calculationInfo.attachingCalculations == 'y',
                reason: calculationInfo.attachingCalculations == 'n'?calculationInfo.notAttachingCalculationsReason:''
            } 

            const disagreeExistingChildSupportInfo: disagreeExistingChildSupportDataInfoType = this.result.disagreeExistingChildSupportSurvey;

            existingChildSupportInfo.disagreeReason = disagreeExistingChildSupportInfo.disagreeReason;
            existingChildSupportInfo.continue = disagreeExistingChildSupportInfo.requestedOrder == 'noChange';
            existingChildSupportInfo.change = disagreeExistingChildSupportInfo.requestedOrder == 'diffChange';
            existingChildSupportInfo.changeExpl = disagreeExistingChildSupportInfo.requestedOrder == 'diffChange'?disagreeExistingChildSupportInfo.requestedChangeDescription:'';  
            
          
        } else {
            const calculationsInfo = {
                attaching: false,
                reason: ''
            }
            const childSupportUnpaid = {
                agreeAmount: false,
                crntDate: '',
                unpaidAmnt: ''
            }
            existingChildSupportInfo = {
            
                agreeCircumstanceChanges: false,
                disAgreeCircumstanceChanges: false,
                agreeSetAside: false,
                section150: false,
                disagreeReason: '',
                continue: false,  
                change: false,
                changeExpl: '',     
                calc: calculationsInfo,
                unpaidDetails: childSupportUnpaid
            }    

        }
        
                

        return existingChildSupportInfo;
    } 
}
